import * as issueWorkflows from 'serviceWorker/db/issueWorkflows/issueWorkflows';
import * as issueWorkflowsService from 'serviceWorker/db/issueWorkflows/issueWorkflowsService';
import { broadcastAllIssueWorkflows } from 'serviceWorker/broadcasts/issueWorkflows';
import { Services } from 'shared/domain/messages/message';
import { workflowContract } from 'shared/domain/workflow/workflowContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';
import { fetchIssueWorkflows } from './fetchIssueWorkflows';

/** Workflows of the selected project; every sync downloads them anew (no sync key). */
export const issueWorkflowsSync = createSyncedEntity({
  entityName: Services.ISSUE_WORKFLOWS,
  contract: workflowContract,
  repository: issueWorkflows,
  service: issueWorkflowsService,
  fetch: fetchIssueWorkflows,
  publishCollection: broadcastAllIssueWorkflows,
});
